import {styled, Typography} from '@mui/material';

const StyledDescription = styled(Typography)`
	text-align: center;
	color: ${({theme}) => theme.colors.light.text.primary};
`;

export {StyledDescription};
